/**
 * This function is used to report errors to Sentry
 * It uses the function `window.guardian.modules.sentry.reportError` set by DCR
 */
const reportError = (error, feature, tags = {}, extras = {}) => {
    try {
        const err = error instanceof Error ? error : new Error(String(error));
        if (window.guardian.modules.sentry?.reportError) {
            window.guardian.modules.sentry.reportError(err, feature, tags, extras);
        }
    }
    catch (e) {
        console.error('Error reporting error to Sentry', e, feature, tags);
    }
};
const wrapWithErrorReporting = (fn, tags = {}, extras = {}) => {
    return function (event) {
        try {
            fn(event);
        }
        catch (e) {
            reportError(e, 'commercial', tags, extras);
        }
    };
};
export { reportError, wrapWithErrorReporting };
